import { defineStore } from 'pinia'

import type { TutorKanbanStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useTutorKanbanStore = defineStore('tutor-kanban', {
  state: (): TutorKanbanStore => ({
    loading: false,
    tutors: null,
    agents: [],
    tutor: null,
    savedStage: null,
    savedStageDetails: {
      reasons: [],
      categories: [],
    },
    savedExitDate: null,
    finalDayConfirmOpen: false,
    pendingStageReasons: null,
    reasonConfirmSource: null,
    reasonResetKey: 0,
    logs: [],
    logsPagination: {
      per_page: 25,
      next_cursor: null,
      next_page_url: null,
      prev_cursor: null,
      prev_page_url: null,
    },
    timeOffs: [],
    isValid: true,
  }),
  actions,
  getters,
})
